import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from "@/components/Home"
import Pricelist from "@/components/Pricelist"
import Dashboard from "@/components/Dashboard"
import Profile from "@/components/Profile"
import Login from "@/components/Login"
import Register from "@/components/Register"
import ForgotPassword from "@/components/ForgotPassword"
import ResetPassword from "@/components/ResetPassword"
import ResendVerification from "@/components/ResendVerification"
import Subscription from "@/components/Subscription"
import ActionView from "@/components/ActionView"
import Coins from "@/components/Coins"
import CoinTransactions from "@/components/CoinTransactions"
import Shop from "@/components/Shop"

import Friends from "@/components/Friends"
import SearchFriends from "@/components/SearchFriends"

import CreateGame from "@/components/CreateGame";
import GameOverview from "@/components/GameOverview";
import GameHistory from "@/components/GameHistory";
import PublicGames from "@/components/PublicGames";
import PublicGame from "@/components/PublicGame";
import UserDetails from "@/components/UserDetails";
import FriendshipRequests from "@/components/FriendshipRequests";
import GameInvitations from "@/components/GameInvitations";

import ErrorView from "@/components/ErrorView";
import SuccessView from "@/components/SuccessView";
import Contact from "@/components/Contact";
import FAQs from "@/components/FAQs";
import Impress from "@/components/Impress";
import DevTools from "@/components/DevTools"
import $store from "@/plugins/store"
import {MUTATION_RAISE_NOTIFICATION} from "@/plugins/store"
import $ga from "@/plugins/ga"
import CompleteUserData from '@/components/CompleteUserData'

const routes = [
  { path: '/', name: 'home', component: Home, meta: {public: true} },
  { path: '/error', component: ErrorView, props: (route) => ({ message: route.query.message }), meta: {public: true} },
  { path: '/success', component: SuccessView, props: (route) => ({ message: route.query.message }), meta: {public: true} },
  { path: '/pricelist', component: Pricelist, meta: {public: true} },
  { path: '/dashboard', name: 'dashboard', component: Dashboard },
  { path: '/profile', name: 'profile', component: Profile },
  { path: '/login', component: Login, name: 'login', meta: {public: true} },
  { path: '/register', name: 'register',component: Register, meta: {public: true} },
  { path: '/resendVerification', component: ResendVerification, meta: {public: true} },
  { path: '/forgotPassword', component: ForgotPassword, meta: {public: true} },
  { path: '/resetPassword/:token', component: ResetPassword, props: true, meta: {public: true} },
  { path: '/contact', name: 'contact', component: Contact },
  { path: '/faq', name: 'faqs', component: FAQs, meta: {public: true} },

  { path: '/action/:actionStr', component: ActionView, props: true, meta: {public: true, gaPageFn: () => {
    return '/action'
  }} },

  { path: '/subscription', component: Subscription }, // deprecated since 29.12.2020
  { path: '/premium', component: Subscription },
  { path: '/coins', name: 'coins',component: Coins },
  { path: '/coins/transactions', component: CoinTransactions },
  { path: '/shop', name: 'shop', component: Shop },

  { path: '/gameInvitations', name: 'competitionInvitations', component: GameInvitations},
  { path: '/game/new', name: 'createCompetition', component: CreateGame},
  { path: '/game/:gameUID', name: 'competition', component: GameOverview, props: (route) => ({ gameUID: route.params.gameUID, tabKey: route.query.tab, secret: route.query.s }), meta: {
    public: true,
    gaPageFn: (to) => {
      return '/game' + (to.query.tab ? '/' + to.query.tab : '')
    }
  }},

  { path: '/user/:userUID', component: UserDetails, props: (route) => ({ uid: route.params.userUID }), meta: {
    gaPageFn: () => {
      return '/user';
    }
  }},

  { path: '/gamehistory', name: 'competitionHistory', component: GameHistory},

  { path: '/competitions/public', name: 'publicCompetitions', component: PublicGames},
  { path: '/competitions/public/:gameUID', name: 'publicCompetition', component: PublicGame, props: (route) => ({ gameUID: route.params.gameUID })},

  { path: '/friends', name: 'friends', component: Friends },
  { path: '/friends/search', name: 'searchFriends', component: SearchFriends },
  { path: '/friendshipRequests', component: FriendshipRequests },

  { path: '/complete-user-data', component: CompleteUserData },

  { path: '/impress', component: Impress, name: 'impress', meta: {public: true} },
  { path: '/devTools', component: DevTools, meta: {public: true} },
]

let router = new VueRouter({
  routes // short for `routes: routes`
})

router.appSecurePush = function(location)
{
  console.log('router.appSecurePush', location)
  if (location && location.length > 0) {
    if (location[0] == '/') {
      router.push(location)
    } else {
      console.log('Invalid location for app secure push', location)
      router.push('/')
    }
  }

}

router.beforeEach((to, from, next) => {
  // console.log('router.beforeEach', to)
  if (to.meta.public) {
    next() // route is public, proceed
    return
  }
  if ($store.state.isLoggedIn) {
    next() // user is authenticated; proceed
    return
  }

  // route is secured, user is not logged in: show warning and redirect to /login
  $store.commit(MUTATION_RAISE_NOTIFICATION, { message: `Bitte melde dich zuerst an`, type: 'warning'} )
  next('/login?redirect=' + to.fullPath.replace('&', '%26'))
})

router.afterEach((to) => { // (to, from)
  let gaData = {hitType: 'pageview'}
  if (to.meta && to.meta.gaPageFn) {
    gaData.page = to.meta.gaPageFn(to)
  }
  Vue.nextTick(() => {
    $ga.send(gaData)
  })
})

export default router
